/**
 * Info banner shown at the top of the Datasets tab.
 *
 * Verbatim copy per `feature-spec.md` §2.3 — golden-record count,
 * remaining-records callout. Star icon mirrors the prototype.
 */

import React from 'react';
import { Star } from 'lucide-react';

import { Alert, AlertDescription } from '../../../../../ui/alert';

interface Props {
  golden: number;
  totalRecords: number;
}

const GoldenDatasetInfoBanner: React.FC<Props> = ({ golden, totalRecords }) => {
  const remaining = Math.max(0, totalRecords - golden);
  return (
    <Alert
      className="border-emerald-200 bg-gradient-to-br from-emerald-50 to-emerald-50/50"
      data-testid="golden-dataset-info-banner"
    >
      <Star className="h-4 w-4 text-emerald-600" aria-hidden="true" />
      <AlertDescription className="block truncate">
        <strong className="font-semibold text-foreground">
          {golden.toLocaleString()} of {totalRecords.toLocaleString()} records
        </strong>{' '}
        are in the golden dataset and available for evaluation.
        {remaining > 0 && ` ${remaining.toLocaleString()} records still need annotation.`}
      </AlertDescription>
    </Alert>
  );
};

export default GoldenDatasetInfoBanner;
